module.exports = __webpack_public_path__ + "components/MapControl/svg/Kamieniołom.svg?ffd3e6e5";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Kamieniołom.svg
// module id = 2045
// module chunks = 0